import {
  typedHttpsCallableWrapper,
  typedOnRequestWrapper
} from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export class APIAuth {
  public static registerNewUser = typedOnRequestWrapper(
    API_ROUTE_CONFIG.auth.user.register
  );

  public static getMe = typedHttpsCallableWrapper(API_ROUTE_CONFIG.auth.me);

  public static updateProfile = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.auth.user.updateProfile
  );

  public static updatePassword = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.auth.user.updatePassword
  );

  public static resetPassword = typedHttpsCallableWrapper(API_ROUTE_CONFIG.auth.user.resetPassword)  
}
